<template>
<div class="product-detail">
  <div class="detail-header">
    <div
      @click="bankHandle"
      class="header-left">
      <i class="el-icon-back icon-el"></i>
      <span class="goback-title">{{$t('product_detail')}}</span>
    </div>
    <div class="header-right">
      <div
        @click="openShopCarHandle"
        class="icon-outer shop-car pr">
        <i class="iconfont icon-gouwuche"></i>
        <div
          v-if="carInfo.cartSize"
          class="shop-car-number pa">
          {{carInfo.cartSize}}
        </div>
      </div>
      <div
        @click="locationHandle"
        class="icon-outer location">
        <i class="iconfont icon-shouhuodizhi"></i>
      </div>
    </div>
  </div>
  <div class="detail-content pc-padding30-mobil-padding20">
    <detail-top
      class="detail-top pc-margin-bottom30-mobil-margin-bottom20"
      :product-detail="detail"
      @addcar-success="addcarSuccessHandle"
    ></detail-top>
    <div class="content-box">
      <div class="title">{{$t('details')}}</div>
      <div class="product-content">
        <div
          class="content-inner ql-container"
          v-html="detail.detail"
        ></div>
      </div>
    </div>
    <shop-car
      ref="shopcar"
      @close="closeHandle"
      :dialog-show="carDialogShow"
      @send-car-data="sendCarData"
      @settlehandle="settlehandle"
    ></shop-car>
    <sure-order
      :car-info="carInfo"
      :settle-product-arr="settleProductArr"
      @close="closeOrderDialogHandle"
      @edit-address="editAddressHandle"
      @exchange-success="exchangeSuccess"
      :dialog-show="sureOrderDialogShow"
    ></sure-order>
    <shipping-address
      :address-info="carInfo.shippingInfo"
      :dialog-show="addressDialogShow"
      @close="closeAddressDialogHandle"
      @add-or-edit-success="addOrEditSuccess"
    ></shipping-address>
  </div>
</div>
</template>

<script>
import shippingAddress from '@/components/integralShop/dialog/shippingAddress';
import sureOrder from '@/components/integralShop/dialog/sureOrder';
import shopCar from '@/components/integralShop/dialog/shopCar';
import { mapGetters } from 'vuex'
import { queryProcutDetail } from '@/api/userCenter'
import detailTop from '@/components/integralShop/detail/detailTop';
export default {
  name: 'productDetail',
  components:{
    detailTop,
    shopCar,
    sureOrder,
    shippingAddress,
  },
  data() {
    return {
      detail:{
        carouselImages: [],
        content: '',
        title: '',
      },
      // 关于弹框
      //购物车:
      carDialogShow: false ,
      sureOrderDialogShow: false ,
      carInfo: {
        shippingInfo: {
          "name": "",
          "nationCode": "+86",
          "phone": "",
          "city": "",
          "detailedAddress": "",
        },
      }, // 购物车信息,包含积分和购物车商品列表和购物车商品数量
      addressDialogShow: false,
      settleProductArr: [],
    };
  },
  created(){
    if(this.language == 'en_US'){
      this.$router.push({name: 'userCenterPerson'});
    }
    this.getDetail();
  },
  mounted() {
    if(this.language == 'en_US'){
      this.$router.push({name: 'dashboard'})
    }
    let reouterview = document.getElementById('routerview');
    if(!reouterview) return;
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    if(reouterview){
      reouterview.classList.remove('no-padding-import');
    }
  },
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    addcarSuccessHandle(){
      this.$refs.shopcar.getCarInfo();
    },
    bankHandle(){
      this.$router.go(-1)
    },
    closeHandle(){
      this.carDialogShow = false;
    },
    closeOrderDialogHandle(){
      this.sureOrderDialogShow = false;
    },
    settlehandle(settleProductArr){
      this.settleProductArr = settleProductArr;
      this.sureOrderDialogShow = true;
    },
    sendCarData(res){
      this.carInfo = res;
    },
    // 确认订单弹框地址编辑,
    editAddressHandle(){
      this.addressDialogShow = true;
    },
    addCarSuccess(){
      this.$refs.shopcar.getCarInfo();
    },
    closeAddressDialogHandle(){
      this.addressDialogShow = false;
    },
    addOrEditSuccess(){
      this.$refs.shopcar.getCarInfo();
      this.addressDialogShow = false;
    },
    exchangeSuccess(){
      this.sureOrderDialogShow = false;
      this.carDialogShow = false;
      this.$refs.shopcar.getCarInfo();
    },
    locationClick(){
      this.addressDialogShow = true;
    },
    getDetail() {
      queryProcutDetail({
          productId: this.$route.params.id
      }).then((res) => {
        this.detail = res.data;
      })
    },
    locationHandle(){
      this.addressDialogShow = true;
    },
    openShopCarHandle(){
      this.carDialogShow = true;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.product-detail {
  .detail-header {
    background-color: #ffffff;
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    .header-left {
      cursor: pointer;
      font-size: 16px;
      .icon-el {
        font-weight: 600;
      }
      .goback-title {
        display: inline-block;
        padding-left: 5px;
      }
    }
    .header-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .icon-outer {
        cursor: pointer;
        width: 28px;
        height: 28px;
        border: 1px solid #E6E6E6;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #333333;
        .iconfont {
          font-size: 20px;
        }
        &.location {
          margin-left: 5px;
        }
        &.shop-car {
          .shop-car-number {
            height: 15px;
            width: 15px;
            border-radius: 50%;
            background-color: $themeColor;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: -10px;
            right: -5px;
            color: #ffffff;
            font-size: 12px;
          }
        }
      }
    }
  }
  .content-box {
    border-radius: 5px;
    background-color: #ffffff;
    .title {
      height: 58px;
      line-height: 58px;
      font-weight: 600;
      font-size: 18px;
      padding-left: 30px;
      border-bottom: 1px solid #E6E6E6;
    }
    .product-content {
      padding: 30px;
      .content-inner {
        /deep/ img {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (min-width: 750px){
  .product-detail {
    .content-inner {
      width: 750px;
      margin: 0 auto;
    }
  }
}
</style>
